import { render, staticRenderFns } from "./CompetitionModal.vue?vue&type=template&id=1c71f0f8&scoped=true"
import script from "./CompetitionModal.vue?vue&type=script&lang=js"
export * from "./CompetitionModal.vue?vue&type=script&lang=js"
import style0 from "./CompetitionModal.vue?vue&type=style&index=0&id=1c71f0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71f0f8",
  null
  
)

export default component.exports